import React from 'react';
import {
  TextField,
  FormControl,
  Grid,
  FormHelperText,
  Typography,
  makeStyles,
} from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Controller} from 'react-hook-form';
import {SsnMaskCustom} from '../../util/SsnMaskFormat';
import {PhoneMaskCustom} from '../../util/PhoneMaskFormat';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';
import {STATE} from '../../constants/Lookup';
import { positiveNumberOnly } from '../../util/Currency';
const useStyles = makeStyles((theme) => ({
  rpInformationLabel: {
    display: 'block',
    margin: '10px',
    fontWeight: '600',
    fontSize: '15px',
  },
}));
function PatientCustomerInformation({
  classes,
  control,
  setValue,
  errors,
  getValues,
  watch,
  handleGetData,
  dropDownData,
}) {
  const componentClasses = useStyles();

  return (
    <>
      <Grid container spacing={2} className="new-standard-textfields">
        {/* Patient first name */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter First Name"
                  margin="dense"
                  name="patientFirstName"
                  variant="outlined"
                  label="First Name"
                  value={value}
                  onChange={onChange}
                  error={Boolean(errors.patientFirstName?.message)}
                  required
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  fullWidth
                />
              )}
              control={control}
              name="patientFirstName"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientFirstName?.message ? errors.patientFirstName.message : ''}
          </FormHelperText>
        </div>
        {/* Patient last name */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter Last Name"
                  margin="dense"
                  name="patientLastName"
                  variant="outlined"
                  label="Last Name"
                  value={value}
                  onChange={onChange}
                  error={Boolean(errors.patientLastName?.message)}
                  required
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  fullWidth
                />
              )}
              control={control}
              name="patientLastName"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientLastName?.message ? errors.patientLastName.message : ''}
          </FormHelperText>
        </div>
        {/* Date of birth */}
        <div className="col-md-4  col-sm-4 col-xl-3 form-group">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container>
              <Controller
                render={({value, onChange}) => (
                  <KeyboardDatePicker
                    className={`${classes.labelName}`}
                    orientation="portrait"
                    format="MM/dd/yyyy"
                    value={value}
                    autoOk
                    maxDate={new Date()}
                    inputVariant="outlined"
                    margin="dense"
                    placeholder="MM/DD/YYYY"
                    fullWidth
                    required
                    label="Birth Date"
                    helperText={null}
                    error={Boolean(errors?.patientDateOfBirth?.message)}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    onChange={(date) => {
                      onChange(date);
                      setValue('patientDateOfBirth', date);
                      return {value: date};
                    }}
                  />
                )}
                control={control}
                name="patientDateOfBirth"
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <FormHelperText variant="outlined">
            {errors.patientDateOfBirth?.message ? errors.patientDateOfBirth.message : ''}
          </FormHelperText>
        </div>
        {/* MRN Number */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  value={value}
                  className={`${classes.labelName}`}
                  placeholder="Enter MRN"
                  margin="dense"
                  name="mrnNumber"
                  variant="outlined"
                  label="MRN"
                  error={Boolean(errors.mrnNumber?.message)}
                  onChange={(e) => onChange(e.target.value)}
                  InputProps={{
                    inputComponent: positiveNumberOnly,
                  }}
                  fullWidth
                />
              )}
              control={control}
              name="mrnNumber"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.mrnNumber?.message ? errors.mrnNumber.message : ''}
          </FormHelperText>
        </div>
        {/* SSN Number */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter SSN"
                  margin="dense"
                  name="ssnNumber"
                  variant="outlined"
                  label="SSN"
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  error={Boolean(errors.ssnNumber?.message)}
                  InputProps={{
                    inputComponent: SsnMaskCustom,
                  }}
                  fullWidth
                />
              )}
              control={control}
              name="ssnNumber"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.ssnNumber?.message ? errors.ssnNumber.message : ''}
          </FormHelperText>
        </div>
        {/* Patient Phone */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter Phone"
                  margin="dense"
                  name="patientPhone"
                  variant="outlined"
                  label="Phone"
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  error={Boolean(errors.patientPhone?.message)}
                  required
                  InputProps={{
                    inputComponent: PhoneMaskCustom,
                  }}
                  fullWidth
                />
              )}
              control={control}
              name="patientPhone"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientPhone?.message ? errors.patientPhone.message : ''}
          </FormHelperText>
        </div>
        {/* Email */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter Email"
                  margin="dense"
                  name="patientEmail"
                  variant="outlined"
                  label="Email"
                  value={value}
                  onChange={onChange}
                  error={Boolean(errors.patientEmail?.message)}
                  fullWidth
                />
              )}
              control={control}
              name="patientEmail"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientEmail?.message ? errors.patientEmail.message : ''}
          </FormHelperText>
        </div>
        {/* Address 1 */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter Address Line 1"
                  margin="dense"
                  name="patientAddressLine1"
                  variant="outlined"
                  label="Address Line 1"
                  value={value}
                  onChange={onChange}
                  error={Boolean(errors.patientAddressLine1?.message)}
                  required
                  fullWidth
                />
              )}
              control={control}
              name="patientAddressLine1"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientAddressLine1?.message ? errors.patientAddressLine1.message : ''}
          </FormHelperText>
        </div>
        {/* Address 2 */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter Address Line 2"
                  margin="dense"
                  name="patientAddressLine2"
                  variant="outlined"
                  label="Address Line 2"
                  value={value}
                  onChange={onChange}
                  error={Boolean(errors.patientAddressLine2?.message)}
                  fullWidth
                />
              )}
              control={control}
              name="patientAddressLine2"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientAddressLine2?.message ? errors.patientAddressLine2.message : ''}
          </FormHelperText>
        </div>
        {/* City */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  className={`${classes.labelName}`}
                  placeholder="Enter City"
                  margin="dense"
                  name="patientCity"
                  variant="outlined"
                  label="City"
                  value={value}
                  onChange={onChange}
                  error={Boolean(errors.patientCity?.message)}
                  required
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  fullWidth
                />
              )}
              control={control}
              name="patientCity"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientCity?.message ? errors.patientCity.message : ''}
          </FormHelperText>
        </div>
        {/* State */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl margin="dense" variant="outlined" fullWidth>
            <Controller
              render={(props) => (
                <GuiAutoComplete
                  {...props}
                  classes={{
                    popper: classes.popper,
                    option: classes.option,
                  }}
                  id="patientState"
                  options={handleGetData(dropDownData, STATE)}
                  size="small"
                  autoHighlight
                  value={props.value}
                  getOptionDisabled={(option) => option.valueCode === null}
                  getOptionLabel={(option) => {
                    return option && option.valueCode && option.value ?
                      option.valueCode + ' - ' + option.value :
                      option.value === null ?
                        option.valueCode :
                        '';
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      variant="outlined"
                      fullWidth
                      className={` ${classes.labelName}`}
                      label="State"
                      error={Boolean(errors?.patientState?.message)}
                      required
                      name="patientState"
                      placeholder="Select State"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off',
                      }}
                    />
                  )}
                  onChange={(_, data) => {
                    props.onChange(data);
                  }}
                />
              )}
              name="patientState"
              control={control}
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientState?.message ? errors.patientState.message : ''}
          </FormHelperText>
        </div>
        {/* Zip */}
        <div className="col-md-4 col-sm-4 col-xl-3 form-group">
          <FormControl variant="outlined" fullWidth>
            <Controller
              render={({value, onChange}) => (
                <TextField
                  value={value}
                  className={`${classes.labelName}`}
                  placeholder="Enter Zip"
                  margin="dense"
                  name="patientZip"
                  variant="outlined"
                  label="Zip"
                  error={Boolean(errors.patientZip?.message)}
                  required
                  onChange={(e) => {
                    if (Number(e.target.value) || e.target.value === '') {
                      onChange(e.target.value);
                    }
                  }}
                  fullWidth
                />
              )}
              control={control}
              name="patientZip"
            />
          </FormControl>
          <FormHelperText variant="outlined">
            {errors.patientZip?.message ? errors.patientZip.message : ''}
          </FormHelperText>
        </div>
      </Grid>
      {watch('patientDateOfBirth') &&
      new Date().getFullYear() - new Date(watch('patientDateOfBirth')).getFullYear() <= 18 ? (
          <>
            <Typography component={'p'} className={componentClasses.rpInformationLabel}>
            RP Information :
            </Typography>
            {/* RP first name */}
            <Grid container spacing={2} className="new-standard-textfields">
              <div className="col-md-4 col-sm-4 col-xl-3 form-group">
                <FormControl variant="outlined" fullWidth>
                  <Controller
                    render={({value, onChange}) => (
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter RP First Name"
                        margin="dense"
                        name="rpFirstName"
                        variant="outlined"
                        label="RP First Name"
                        value={value}
                        onChange={onChange}
                        error={Boolean(errors.rpFirstName?.message)}
                        required
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        fullWidth
                      />
                    )}
                    control={control}
                    name="rpFirstName"
                  />
                </FormControl>
                <FormHelperText variant="outlined">
                  {errors.rpFirstName?.message ? errors.rpFirstName.message : ''}
                </FormHelperText>
              </div>
              {/* RP last name */}
              <div className="col-md-4 col-sm-4 col-xl-3 form-group">
                <FormControl variant="outlined" fullWidth>
                  <Controller
                    render={({value, onChange}) => (
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter RP Last Name"
                        margin="dense"
                        name="rpLastName"
                        variant="outlined"
                        label="RP Last Name"
                        value={value}
                        onChange={onChange}
                        error={Boolean(errors.rpLastName?.message)}
                        required
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        fullWidth
                      />
                    )}
                    control={control}
                    name="rpLastName"
                  />
                </FormControl>
                <FormHelperText variant="outlined">
                  {errors.rpLastName?.message ? errors.rpLastName.message : ''}
                </FormHelperText>
              </div>
              {/* SSN Number */}
              <div className="col-md-4 col-sm-4 col-xl-3 form-group">
                <FormControl variant="outlined" fullWidth>
                  <Controller
                    render={({value, onChange}) => (
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter RP SSN"
                        margin="dense"
                        name="rpSSN"
                        variant="outlined"
                        label="RP SSN"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={Boolean(errors.rpSSN?.message)}
                        InputProps={{
                          inputComponent: SsnMaskCustom,
                        }}
                        fullWidth
                      />
                    )}
                    control={control}
                    name="rpSSN"
                  />
                </FormControl>
                <FormHelperText variant="outlined">
                  {errors.rpSSN?.message ? errors.rpSSN.message : ''}
                </FormHelperText>
              </div>
              {/* Patient Phone */}
              <div className="col-md-4 col-sm-4 col-xl-3 form-group">
                <FormControl variant="outlined" fullWidth>
                  <Controller
                    render={({value, onChange}) => (
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter RP Phone"
                        margin="dense"
                        name="rpPhone"
                        variant="outlined"
                        label="RP Phone"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={Boolean(errors.rpPhone?.message)}
                        InputProps={{
                          inputComponent: PhoneMaskCustom,
                        }}
                        fullWidth
                      />
                    )}
                    control={control}
                    name="rpPhone"
                  />
                </FormControl>
                <FormHelperText variant="outlined">
                  {errors.rpPhone?.message ? errors.rpPhone.message : ''}
                </FormHelperText>
              </div>
            </Grid>
          </>
        ) : null}
    </>
  );
}

export default PatientCustomerInformation;
